module.exports = __webpack_public_path__ + "static/media/send-letter-info-img5@2x.d23d7bbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send-letter-info-img5@2x.png
// module id = 1320
// module chunks = 1